// extracted by mini-css-extract-plugin
module.exports = {"mobileBlock":"_2Eu1fGA_3RclywCC","title":"_1fnpClN4qppUW8yK","subTitle":"_1e-GItUUSFCPnU-p"};